import BusinessInformation from "./Container"

export default BusinessInformation
